import React from "react";

const QuestionsAndChoices = () => {
  return <div>QuestionsAndChoices</div>;
};

export default QuestionsAndChoices;
